// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout__Content__3KSp3"};